var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#0057FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9098 11.1201V6.73007C20.9098 5.91007 20.2898 4.98007 19.5198 4.67007L13.9498 2.39007C12.6998 1.88007 11.2898 1.88007 10.0398 2.39007L4.46984 4.67007C3.70984 4.98007 3.08984 5.91007 3.08984 6.73007V11.1201C3.08984 16.0101 6.63984 20.5901 11.4898 21.9301C11.8198 22.0201 12.1798 22.0201 12.5098 21.9301C17.3598 20.5901 20.9098 16.0101 20.9098 11.1201ZM12.7498 12.8701V15.5001C12.7498 15.9101 12.4098 16.2501 11.9998 16.2501C11.5898 16.2501 11.2498 15.9101 11.2498 15.5001V12.8701C10.2398 12.5501 9.49984 11.6101 9.49984 10.5001C9.49984 9.12007 10.6198 8.00007 11.9998 8.00007C13.3798 8.00007 14.4998 9.12007 14.4998 10.5001C14.4998 11.6201 13.7598 12.5501 12.7498 12.8701Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityFilled);
export default __webpack_public_path__ + "static/media/SecurityFilled.22f3823917f67af9b7f923edd1bdf32e.svg";
export { ForwardRef as ReactComponent };